export const defaultState = {
    loading: {
        assessment_point: false,
        current_rt: true,
        full_submission: [],
    },
    saving: false,
    currentRT: {
        id: null,
        peer_assessment_questions: [],
        anonymity_details: [],
        title: 'Title',
        submissions: [],
        points_settings: {
            peer_rewards: [],
        },
        type: null,
        invites: [{ code: 'aaa' }],
        links: [],
        course_id: null,
        reveal_names: false,
        is_sample: false,
        is_generated_by: 'from_scratch'
    },
    grades: {
        summary: {
            comments: null,
            reflections: {
                completed: null,
                pending: null,
            },
            responses: {
                completed: null,
                pending: null,
            },
            submissions: [],
            submission: {},
        },
        student: {
            automated_feedback: [],
            submission_id: null,
            total_points: null,
            comments: [],
            diversity_info: {},
            points_settings: {
                peer_rewards: [],
            },
            peer_rewards: {
                rt_positive_response: {
                    count: null,
                    points: null,
                    teacher: null,
                    peer: null,
                },
            },
            activity_rewards: {
                rt_response: {
                    count: null,
                    points: null,
                },
                rt_comment: {
                    count: null,
                    points: null,
                },
            },
            user: {
                id: null,
                name: null,
            },
            evaluation: {
                grade: null,
                comment: null,
            },
            reflection: [],
            my_comments: [],
        },
    },
    userInSummaryOverlay: false
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/onlineRoundtables.defaultState.js